import { AnimatePresence, m, type Variants } from "motion/react";
import { useLocation, useOutlet } from "react-router";

/**
 * Route transitions. `useOutlet()` returns an element bound to this location's match, so a
 * page that is leaving keeps showing its own content while it animates out (a plain
 * <Outlet /> would already show the next page).
 */
export function AnimatedOutlet({
  variants,
  custom,
  className,
}: {
  variants: Variants;
  custom?: number;
  className?: string;
}) {
  const location = useLocation();
  const outlet = useOutlet();
  return (
    <AnimatePresence mode="wait" initial={false} custom={custom}>
      <m.div
        key={location.pathname}
        className={className}
        custom={custom}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
      >
        {outlet}
      </m.div>
    </AnimatePresence>
  );
}
